<template>
    <section  v-if="hasPermissions(['Utilities-Project-Codes-Mass-Delete Read'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
                To delete a task on many rooms at one time, select Daily, Project, or Policing. Select a task. Enter a frequency (optional). Click "Show Results".  Narrow your search by selecting a Building, Level, and Area. Select all rooms or individual rooms. Click "Delete Codes".
            </p>
        </div>

        <RoomTaskAdvancedSearchVue
            class="mt-5"
            ref="advanced_search"
            :checkeable="true"
            :rest_api="rest_api"
            :rest_api_pagination="rest_api_pagination"
            :table_headers="table_headers"
            :filter_options="filter_options"
            @passInitialData="getInitialData($event)"
        />

        <div class="row py-0 d-flex justify-content-md-end">
            <div class="col-md-12">
                <button class="mx-md-0 modal__buttons__item w-auto float-right px-3" v-html="'Delete Codes'" @click="delete_codes()"/>
            </div>
        </div>

        <WaitingModal/>
    </section>
    <div v-else>
        <UnauthorizedComponent :breadcrumb="breadcrumb"/>
    </div>
</template>

<script>

import FormResources from './form_resources'
import Breadcrumb from '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal from '@/components/WaitingModal'
import Resources from './resources'
import RoomTaskAdvancedSearchVue from '@/components/BuildingComponent/Rooms/RoomTaskAdvancedSearch/RoomTaskAdvancedSearch.vue'
import UnauthorizedComponent from   '@/components/UnauthorizedComponent'
import 'vuetify/dist/vuetify.min.css'
import { Notyf } from 'notyf'
import 'notyf/notyf.min.css' // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

export default {

    name: 'ProjectCodeMassDelete',

    components: {
        Breadcrumb,
        WaitingModal,
        RoomTaskAdvancedSearchVue,
        UnauthorizedComponent
    },
    
    data() 
    {
        return {
            notyf,
            title_page:           'Mass Delete Codes',
            title_room_tab:       'Rooms',
            rest_api:             `project_code_delete`,
            rest_api_pagination:  'project_code_delete_pagination',
            table_headers:        Resources.table_headers,
            breadcrumb:           Resources.breadcrumb,
            filter_options:       Resources.filter_options,
            radio_options:        FormResources.radio_options,
            form_data:            FormResources.form_data,
            form_format:          FormResources.form_format,
            form_format_project:  FormResources.form_format_project,
            room_form_format:     FormResources.room_form_format,
            add_btn:              '',
            single_select:        false,
            table_selection:      [],
            search:               '',
            global_index:         '',
            single_object:        {},
            tasks:                [],
            room_list:            [],
            rooms:                [],
            array_options:        {},
            delete_task_id:       null,
        }
    },

    watch:{

        'form_data.frequency_manual'(val)
        {
            if(val < 0 || val > 65)
            {
                this.form_data.frequency_manual = 1
            }
        },

        'form_data.type'(val)
        {
            this.form_data.task_id = ''

            if(val)
            {
                if(val == 'daily')
                {
                    this.array_options.task_id = this.tasks.filter(item => !item.project && !item.policing)
                }
                else if(val == 'policing')
                {
                    this.array_options.task_id = this.tasks.filter(item => !item.project && item.policing)
                }
                else if(val == 'project')
                {
                    this.array_options.task_id = this.tasks.filter(item => item.project && !item.policing)
                }
                
                this.array_options.task_id.length ? notyf.success('Tasks available') : notyf.error('No tasks found')
                this.form_format[0].disabled = false
                this.form_format[1].disabled = false
                this.form_format_project[0].disabled = false
                this.form_format_project[1].disabled = false
            }
        },

        async 'form_data.building_id'(val)
        {
            if(val)
            {
                this.loader(true)

                let http_request = {
                    id: val,
                    level: true,
                }
                
                const response = await this.get(`${this.rest_api}/${JSON.stringify(http_request)}`);

                this.loader()

                if(response.status)
                {
                    if(response.data.levels.length)
                    {
                        this.array_options['level_id'] = response.data.levels
                        this.form_data.level_id = ''
                        this.form_data.area_id = ''
                        notyf.success('Levels available')
                    }
                    else
                    {
                        this.array_options['level_id'] = []
                        this.form_data.level_id = ''
                        this.array_options['area_id'] = []
                        this.form_data.area_id = ''
                        notyf.error('No levels available for the selected building')
                    }
                }
                else
                {
                    this.error_handling(response)
                }
            }
        },

        async 'form_data.level_id'(val)
        {
            if(val)
            {
                this.loader(true)

                let http_request = {
                    id: val,
                    area: true,
                }

                const response = await this.get(`${this.rest_api}/${JSON.stringify(http_request)}`);

                this.loader()

                if(response.status)
                {
                    if(response.data.areas.length)
                    {
                        this.array_options['area_id'] = response.data.areas
                        this.form_data.area_id = ''
                        notyf.success('Areas available')
                    }
                    else
                    {
                        this.array_options['area_id'] = []
                        this.form_data.area_id = ''
                        notyf.error('No areas available for the selected level')
                    }
                }
                else
                {
                    this.error_handling(response)
                }
            }
        },

    },

    computed: {

        display_data()
        {
            return this.rooms.filter( item => this.form_data.building_id !== '' ? item.building_id === this.form_data.building_id : item )
            .filter( item => this.form_data.level_id !== '' ? item.level_id === this.form_data.level_id : item )
            .filter( item => this.form_data.area_id !== '' ? item.area_id === this.form_data.area_id : item )
            .filter( item => this.form_data.description !== '' ? item.description !== null ? item.description.toLowerCase().includes(this.form_data.description.toLowerCase()) : null : item )
        },

    },

    methods: 
    {

        async live_searching()
        {
            if(this.form_data.task_id === '')
            {
                notyf.error('No task selected')
                return false
            }

            this.delete_task_id = this.form_data.task_id

            let response = await this.queryGetByMethod(this.rest_api, this.form_data, 'post')
            
            if(response.status)
            {
                this.table_selection = []
                this.rooms = response.data
                this.rooms.length ? notyf.success('Success') : notyf.error('No rooms available')
            }
        },

        async delete_codes()
        {
            let room_tasks_selected = this.$refs.advanced_search.returnedRoomsToParent()

            if(!room_tasks_selected.checked_items.length && !room_tasks_selected.select_all)
            {
                notyf.error('No rooms selected')
                return false
            }
            room_tasks_selected.unchecked_items = room_tasks_selected.unchecked_items.map(item => item.room_task_id)

            let confirmation = confirm('Only selected records will be deleted. Do you want to proceed?')

            if(confirmation)
            {
                room_tasks_selected.checked_items = room_tasks_selected.checked_items.map(item => item.room_task_id)

                let response = await this.post(`${this.rest_api}`, room_tasks_selected)

                if(response.status)
                {
                    this.$refs.advanced_search.removingRoomTasks(response.data.deleted_ids, true)

                    notyf.success('Success')
                }

                this.$refs.advanced_search.resetSelectAll()
            }
        },

        fill_data(data)
        {
            this.array_options = {
                task_id: [],
                building_id: data.buildings,
                level_id: [],
                area_id: [],
                frequency_id: data.frequencies,
            }
            this.tasks = data.tasks
        },

    },

    async mounted()
    {
        if(this.hasPermissions(['Utilities-Project-Codes-Mass-Delete Read']) )
        {
            await this.api_request()
        }
    }

}

</script>
